import { getApiUrl, PAYMENT_API_URL } from '../../util/api/api'

const finalizePayment = async (basketId: string) => {
  const fetchResponse = await fetch(
    getApiUrl(`${PAYMENT_API_URL}/${basketId}/finalize`), {
      headers: {
        'Content-Type': 'application/json',
      },
      mode: 'cors',
      credentials: 'include',
    }
  )

  if (fetchResponse?.ok) {
    const responseData = await fetchResponse.text()
    return Promise.resolve({ status: fetchResponse.status, data: responseData})
  }
  if (!fetchResponse) return Promise.reject(null)

  const correlationId = fetchResponse.headers?.get('x-correlation-id') || undefined
  return Promise.reject({
    status: fetchResponse.status,
    data: fetchResponse.statusText,
    ...(correlationId && { correlationId }),
  })
}

export default finalizePayment
